// Standalone, conversion-focused landing pages (no blog/Ratgeber).
export const landingPages = {
  "geschaeftsidee-pruefen-lassen": {
    path: "/geschaeftsidee-pruefen-lassen",
    breadcrumb: "Geschäftsidee prüfen lassen",
    headerNote: "2 Minuten · Anonym · KI-gestützt",
    formQuery: "",
    seo: {
      title: "Geschäftsidee prüfen lassen – KI-Check in 2 Minuten | Gründio",
      description:
        "Lass deine Geschäftsidee von der KI prüfen: Score-Tendenz, Marktpotenzial im Einzugsgebiet, Kostenfallen und Risiken. Score-Tendenz kostenlos – der vollständige Gründio Report für 29 €.",
      keywords:
        "Geschäftsidee prüfen lassen, Geschäftsidee validieren, Idee testen, Marktpotenzial prüfen, Existenzgründung, Selbstständigkeit validieren",
    },
    eyebrow: "Idee-Check · KI-gestützt",
    h1: { pre: "Lass deine ", grad: "Geschäftsidee prüfen", post: ", bevor sie Geld kostet." },
    sub:
      "In 2 Minuten liefert dir die KI eine ehrliche Ersteinschätzung mit Score, Marktpotenzial in deinem PLZ-Einzugsgebiet und den größten Risiken – die belastbare Grundlage, bevor du Zeit, Erspartes oder einen Kredit investierst.",
    ctaLabel: "Kostenlosen Score-Check starten",
    ctaNote: "Score-Tendenz gratis · Report 29 €",
    legal: "Automatisierte Orientierungshilfe & KI-gestütztes Express-Feedback. Keine Rechts- oder Steuerberatung.",
    stats: [
      ["0 €", "Ersteinschätzung"],
      ["2 Min.", "bis zum Score"],
      ["über 10 Seiten", "Voll-Report"],
      ["100 %", "anonym & datensparsam"],
    ],
    checklistTitle: "Dein Report deckt auf",
    checklist: [
      "Realistischer Score (0–100) mit nachvollziehbarer Begründung",
      "Marktpotenzial & Wettbewerb in deinem PLZ-Einzugsgebiet",
      "Versteckte Kostenfallen und Auflagen deiner Branche",
      "Rechtsform- und Förder-Orientierung",
      "Konkreter 30-Tage-Plan für den Start",
      "Sofort-Download",
    ],
    factsTitle: "Warum eine Prüfung vor dem Start?",
    facts: [
      { title: "Fehler früh finden", desc: "Die teuersten Fehler stecken in unrealistischen Kosten, zu breiter Zielgruppe oder einem gesättigten Markt – besser vorher als nachher." },
      { title: "Ehrlich statt schön", desc: "Die KI benennt Chancen UND Risiken ausgewogen und mit Begründung – kein Schönreden, keine Erfolgsgarantie." },
      { title: "Perfekte Vorarbeit", desc: "Ideale Grundlage für Businessplan, Bankgespräch oder die fachkundige Stelle – strukturiert und auf den Punkt." },
      { title: "Keine Beratung im Rechtssinne", desc: "Gründio ist ein KI-gestützter Denkanstoß, keine Rechts- oder Steuerberatung. Die finale Prüfung liegt bei dir bzw. Fachberatern." },
    ],
    stepsTitle: "So funktioniert's",
    steps: [
      { title: "Ein paar gezielte Fragen", desc: "Beantworte in 2 Minuten Fragen zu Idee, Standort (PLZ), Zielgruppe und Budget." },
      { title: "Sofort Score-Tendenz & Highlights", desc: "Die KI liefert dir kostenlos eine erste Score-Tendenz und drei ehrliche Kernaussagen." },
      { title: "Voll-Report freischalten", desc: "Für 29 € erhältst du den PDF-Report (über 10 Seiten) mit Markt-, Kosten- und Förder-Orientierung plus 30-Tage-Plan." },
    ],
    darkTitle: "Erst kostenlos die Score-Tendenz holen.",
    darkText: "In 2 Minuten zeigt dir die KI, wo dein Konzept stark ist und wo es noch Lücken hat – ohne Anmeldung, ohne Risiko.",
    faq: [
      { q: "Ersetzt die Prüfung einen Businessplan?", a: "Nein – sie ist eine schnelle Orientierungshilfe und ideale Vorarbeit. Den vollständigen Businessplan und die finale Prüfung übernimmst du bzw. qualifizierte Fachberater." },
      { q: "Wie schnell bekomme ich ein Ergebnis?", a: "Die kostenlose Erst-Einschätzung mit Score-Tendenz erscheint sofort. Der ausführliche Report mit exaktem Score steht in der Regel innerhalb weniger Minuten bereit." },
      { q: "Ist meine Idee dabei sicher?", a: "Die Nutzung ist datensparsam und für die Erst-Einschätzung anonym – du musst keine persönlichen Daten angeben." },
      { q: "Wie entsteht der Score?", a: "Die KI bewertet Markt, Wettbewerb, Zielgruppe und Umsetzbarkeit und leitet daraus eine ehrliche Gesamteinschätzung von 0–100 ab. Es ist eine Einschätzung mit Vorbehalt, keine Garantie." },
    ],
  },

  einstiegsgeld: {
    path: "/einstiegsgeld",
    breadcrumb: "Einstiegsgeld (Bürgergeld)",
    headerNote: "Für Bürgergeld-Beziehende",
    formQuery: "",
    seo: {
      title: "Einstiegsgeld beim Jobcenter: Selbstständig aus dem Bürgergeld | Gründio",
      description:
        "Einstiegsgeld (§ 16b SGB II) beim Jobcenter beantragen: Voraussetzungen, häufige Ablehnungsgründe und die optimale Vorbereitung. Score-Tendenz kostenlos, vollständiger Gründio Report für 29 €.",
      keywords:
        "Einstiegsgeld Jobcenter, Bürgergeld selbstständig, § 16b SGB II, Businessplan Jobcenter, Tragfähigkeit, Existenzgründung Bürgergeld",
    },
    eyebrow: "Bürgergeld · Jobcenter",
    h1: { pre: "Selbstständig aus dem ", grad: "Bürgergeld", post: " – mit einem überzeugenden Antrag." },
    sub:
      "Das Einstiegsgeld ist eine Ermessensleistung – du bekommst nur eine echte Chance, wenn dein Vorhaben nachvollziehbar tragfähig wirkt. Die KI strukturiert deine Idee, deckt Lücken in Kosten und Markt auf und liefert dir eine belastbare Grundlage für das Gespräch beim Jobcenter.",
    ctaLabel: "Kostenlosen Score-Check starten",
    ctaNote: "Score-Tendenz gratis · Report 29 €",
    legal: "Gründio ist eine KI-gestützte Orientierungshilfe – keine Rechts-, Steuer- oder Behördenberatung und keine Tragfähigkeitsbescheinigung.",
    stats: [
      ["§ 16b", "SGB II · Einstiegsgeld"],
      ["Ermessen", "kein Rechtsanspruch"],
      ["Tragfähig­keit", "meist Voraussetzung"],
      ["0 €", "für den Erst-Check"],
    ],
    checklistTitle: "Deine Vorbereitung enthält",
    checklist: [
      "Strukturierte Grundlage für Businessplan & Jobcenter-Gespräch",
      "Realistischer Score (0–100) mit Begründung",
      "Markt-, Kosten- und Nischen-Einordnung für dein Vorhaben",
      "Förder-Orientierung (KfW & Landesbanken)",
      "Hinweise zu Rechtsform & typischen Ablehnungsgründen",
      "Sofort-Download",
    ],
    factsTitle: "Das solltest du zum Einstiegsgeld wissen",
    facts: [
      { title: "Was es ist", desc: "Eine mögliche Förderung des Jobcenters (§ 16b SGB II) für Bürgergeld-Beziehende, die sich hauptberuflich selbstständig machen." },
      { title: "Ermessensleistung", desc: "Es besteht kein Rechtsanspruch – die Sachbearbeitung entscheidet im Einzelfall. Eine gute Vorbereitung erhöht die Chancen deutlich." },
      { title: "Tragfähigkeit", desc: "Häufig ist eine Stellungnahme einer fachkundigen Stelle (IHK, HWK, Steuerberater) nötig. Gründio bereitet dich darauf vor, ersetzt sie aber nicht." },
      { title: "Häufige Ablehnung", desc: "Anträge scheitern meist nicht an der Branche, sondern an fehlender Finanzplanung, unklarer Zielgruppe und undurchdachten Kosten." },
    ],
    stepsTitle: "So gehst du vorbereitet ins Jobcenter",
    steps: [
      { title: "Idee strukturieren", desc: "Beantworte gezielte Fragen zu Idee, Standort, Zielgruppe und Budget – in 2 Minuten." },
      { title: "Score-Tendenz & Lücken erkennen", desc: "Die KI zeigt dir kostenlos eine Score-Tendenz und die größten Schwachstellen deines Konzepts." },
      { title: "Report als Grundlage", desc: "Der PDF-Report (über 10 Seiten) dient als saubere Vorarbeit für Businessplan und Tragfähigkeitsprüfung." },
    ],
    darkTitle: "Erst kostenlos das Express-Feedback holen.",
    darkText: "Bevor du zum Jobcenter oder zur fachkundigen Stelle gehst, zeigt dir die KI, wo dein Konzept noch überzeugender werden muss.",
    faq: [
      { q: "Bekomme ich das Einstiegsgeld sicher?", a: "Nein, es ist eine Ermessensleistung. Eine gute, nachvollziehbare Vorbereitung erhöht deine Chancen deutlich. Über die Bewilligung entscheidet dein Jobcenter." },
      { q: "Brauche ich eine Tragfähigkeitsbescheinigung?", a: "Häufig ja. Diese stellt eine fachkundige Stelle (z. B. IHK, HWK, Steuerberater) aus – unser Report ersetzt sie nicht, bereitet dich aber optimal darauf vor." },
      { q: "Ist das eine Beratung des Jobcenters?", a: "Nein. Dies ist eine KI-gestützte Orientierungshilfe und keine Rechts- oder Behördenberatung. Verbindliche Auskünfte gibt dein Jobcenter." },
      { q: "Was kostet der Erst-Check?", a: "Die Ersteinschätzung mit Score-Tendenz ist kostenlos. Der ausführliche PDF-Report mit exaktem Score ist kostenpflichtig (Einführungspreis 29 €) und steht sofort zum Download bereit." },
    ],
  },
};
